"use client";
import { useWatchedJobs } from "~/hooks/use-watched-jobs";
import type { SimilarJob } from "~/types/job";
import Star from "../icons/star-eon";
import { Button, type ButtonProps } from "./button-eon";

interface WatchJobsToggleProps {
  className?: string;
  jobData: SimilarJob;
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
}

export function WatchJobButton({
  jobData,
  variant,
  size,
  className,
  ...props
}: WatchJobsToggleProps) {
  const [watchedJobs, setWatchedJobs] = useWatchedJobs();

  const isWatched =
    watchedJobs.some((entry) => entry.idClient === jobData.idClient) ?? false;

  function handleWatchJobs() {
    if (!jobData) {
      return;
    }

    setWatchedJobs((prevJobs) =>
      isWatched
        ? prevJobs.filter((entry) => entry.idClient !== jobData.idClient)
        : [...prevJobs, jobData]
    );
  }

  return (
    <Button
      className={className}
      onClick={handleWatchJobs}
      size={size}
      variant={variant}
      {...props}
    >
      <Star
        className={
          isWatched ? "size-6 fill-current stroke-2" : "size-6 stroke-2"
        }
      />
    </Button>
  );
}
